import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { db } from '../firebase';
import {
 collection,
 addDoc,
 query,
 orderBy,
 onSnapshot,
 serverTimestamp,
} from 'firebase/firestore';

export default function Comments({ articleSlug, isDark, accent }) {
 const { user } = useAuth();
 const [comments, setComments] = useState([]);
 const [text, setText] = useState('');
 const [posting, setPosting] = useState(false);

 const muted = isDark ? 'rgba(255,255,255,0.4)' : 'rgba(0,0,0,0.4)';
 const inputBg = isDark ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.04)';
 const inputBorder = isDark ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)';
 const cardBg = isDark ? 'rgba(255,255,255,0.03)' : 'rgba(0,0,0,0.02)';

 useEffect(() => {
  const q = query(
   collection(db, 'comments', articleSlug, 'messages'),
   orderBy('createdAt', 'desc')
  );
  const unsub = onSnapshot(q, (snap) => {
   setComments(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
  }, (err) => {
   console.log('Comments unavailable:', err.message);
  });
  return unsub;
 }, [articleSlug]);

 async function handlePost(e) {
  e.preventDefault();
  if (!text.trim() || !user) return;
  setPosting(true);
  try {
   await addDoc(collection(db, 'comments', articleSlug, 'messages'), {
    text: text.trim(),
    authorName: user.displayName || 'Anonymous',
    authorId: user.uid,
    createdAt: serverTimestamp(),
   });
   setText('');
  } catch (err) {
   console.error('Failed to post:', err);
  }
  setPosting(false);
 }

 function timeAgo(ts) {
  if (!ts) return 'just now';
  const secs = Math.floor((Date.now() - ts.toDate().getTime()) / 1000);
  if (secs < 60) return 'just now';
  if (secs < 3600) return `${Math.floor(secs / 60)}m ago`;
  if (secs < 86400) return `${Math.floor(secs / 3600)}h ago`;
  return `${Math.floor(secs / 86400)}d ago`;
 }

 return (
  <div style={{
   marginTop: '3rem',
   paddingTop: '2rem',
   borderTop: `1px solid ${isDark ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.08)'}`,
  }}> <h3 style={{
    fontFamily: "'Arial', 'Helvetica Neue', sans-serif",
    fontSize: '0.75rem',
    letterSpacing: 3,
    color: accent,
    marginBottom: '1.5rem',
   }}> COMMENTS {comments.length > 0 && `(${comments.length})`}
   </h3> {/* Post box */}
   {user ? (
    <form onSubmit={handlePost} style={{ marginBottom: '1.5rem' }}> <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'flex-start' }}> <div style={{ width: 32, height: 32, borderRadius: '50%', background: accent, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, fontFamily: "'Arial', 'Helvetica Neue', sans-serif", fontSize: '0.75rem', fontWeight: 700, color: '#fff' }}> {(user.displayName || 'A')[0].toUpperCase()}
      </div> <div style={{ flex: 1 }}> <textarea
        value={text}
        onChange={e => setText(e.target.value)}
        placeholder="Leave a comment..."
        rows={3}
        style={{
         width: '100%',
         fontFamily: "'Arial', 'Helvetica Neue', sans-serif",
         fontSize: '0.9rem',
         padding: '0.8rem',
         borderRadius: 10,
         border: `1px solid ${inputBorder}`,
         background: inputBg,
         color: isDark ? '#fff' : '#111',
         outline: 'none',
         resize: 'vertical',
         lineHeight: 1.5,
        }}
       /> <button
        type="submit"
        disabled={!text.trim() || posting}
        style={{
         fontFamily: "'Arial', 'Helvetica Neue', sans-serif",
         fontSize: '0.75rem',
         fontWeight: 600,
         letterSpacing: 2,
         padding: '0.5rem 1.2rem',
         borderRadius: 50,
         border: 'none',
         background: accent,
         color: '#fff',
         cursor: !text.trim() || posting ? 'not-allowed' : 'pointer',
         opacity: !text.trim() || posting ? 0.4 : 1,
         marginTop: '0.5rem',
        }}
       > {posting ? '...' : 'POST'}
       </button> </div> </div> </form> ) : (
    <p style={{
     fontFamily: "'Arial', 'Helvetica Neue', sans-serif",
     fontSize: '0.85rem',
     color: muted,
     textAlign: 'center',
     padding: '1.5rem',
     background: cardBg,
     borderRadius: 12,
     marginBottom: '1.5rem',
    }}> Sign in to leave a comment
    </p> )}

   {/* Comment list */}
   <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}> {comments.map((c) => (
     <div key={c.id} style={{ display: 'flex', gap: '0.6rem', alignItems: 'flex-start' }}> <div style={{ width: 28, height: 28, borderRadius: '50%', background: `${accent}40`, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, fontFamily: "'Arial', 'Helvetica Neue', sans-serif", fontSize: '0.65rem', fontWeight: 700, color: accent }}> {(c.authorName || 'A')[0].toUpperCase()}
      </div> <div style={{ flex: 1 }}> <div style={{ display: 'flex', alignItems: 'baseline', gap: '0.5rem' }}> <span style={{ fontFamily: "'Arial', 'Helvetica Neue', sans-serif", fontSize: '0.8rem', fontWeight: 600 }}>{c.authorName}</span> <span style={{ fontSize: '0.65rem', color: muted }}>{timeAgo(c.createdAt)}</span> </div> <p style={{ fontFamily: "'Arial', 'Helvetica Neue', sans-serif", fontSize: '0.85rem', lineHeight: 1.5, color: isDark ? 'rgba(255,255,255,0.7)' : 'rgba(0,0,0,0.7)', marginTop: '0.2rem' }}> {c.text}
       </p> </div> </div> ))}
    {comments.length === 0 && (
     <p style={{ fontFamily: "'Arial', 'Helvetica Neue', sans-serif", fontSize: '0.8rem', color: muted, textAlign: 'center', padding: '1rem' }}> No comments yet. Be the first!
     </p> )}
   </div> </div> );
}
